import request from '@/utils/request'

// 공사 관리 조회
export function getConstructManage(params, isNotify) {
  return request({
    url: `/api/getConstructManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 공사 관리 저장
export function saveConstructManage(params, isNotify) {
  return request({
    url: `/api/saveConstructManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
// 공사 관리 상세페이지 공통코드 조회
export function getConstructManageDetailCommonCode(params, isNotify) {
  return request({
    url: `/api/getConstructManageDetailCommonCode`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 공사 관리 상세페이지 조회
export function getConstructManageDetail(params, isNotify) {
  return request({
    url: `/api/getConstructManageDetail`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 공사 관리 상세페이지 저장
export function saveConstructManageDetail(params, isNotify) {
  return request({
    url: `/api/saveConstructManageDetail`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
// 공사 관리 상세페이지 승인요청
export function approveConstructManageDetail(params) {
  return request({
    url: `/api/approveConstructManageDetail`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
  })
}
// 공사 관리 상세페이지 재승인요청
export function reApproveConstructManageDetail(params) {
  return request({
    url: `/api/reApproveConstructManageDetail`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
  })
}

// 결제정보 order_history 삽입 및 construct 테이블 업데이트
export function updateConstructOrderData (params, isNotify) {
  return request({
    url: `/api/updateConstructOrderData`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}

// 해지 요청
export function requestCancellation (params, isNotify) {
  return request({
    url: `/api/requestCancellation`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}

// 결제 정보 요청
export function getPaymentInfo (params, isNotify) {
  return request({
    url: `/api/getPaymentInfo`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}

// 결제 요약 정보 요청
export function getPaymentSummary(params, isNotify) {
  return request({
    url: `/api/getPaymentSummary`,
    method: 'GET',
    params: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}

// 월 구독 결제 이력 요청
export function getMonthlyAutoPaymentHistory (params, isNotify) {
  return request({
    url: `/api/getMonthlyAutoPaymentHistory`,
    method: 'POST',
  data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}

// 일반 결제 이력 요청
export function getNormalPaymentHistory (params, isNotify) {
  return request({
    url: `/api/getNormalPaymentHistory`,
    method: 'POST',
  data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}

// 청구서 출력
export function getBillReport(param, isNotify) {
  let responseType = 'blob'
  return request({
    url: '/api/getBillReport',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' },
    responseType: responseType
  })
}